import { useState } from 'react';

interface PromptInputProps {
  onSubmit: (prompt: string) => void;
  isLoading: boolean;
}

export default function PromptInput({ onSubmit, isLoading }: PromptInputProps) {
  const [value, setValue] = useState('');
  const [validationError, setValidationError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (value.trim().length === 0) {
      setValidationError('Prompt cannot be empty.');
      return;
    }

    setValidationError(null);
    onSubmit(value.trim());
    setValue('');
  };

  return (
    <form className="prompt-input" onSubmit={handleSubmit}>
      <div className="prompt-input-row">
        <label htmlFor="prompt-textarea" className="sr-only">
          Enter your prompt
        </label>
        <textarea
          id="prompt-textarea"
          className="prompt-textarea"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            if (validationError) setValidationError(null);
          }}
          placeholder="Type your message..."
          disabled={isLoading}
          aria-label="Enter your prompt"
          aria-invalid={validationError ? 'true' : undefined}
          aria-describedby={validationError ? 'prompt-error' : undefined}
          rows={2}
        />
        <button
          className="prompt-submit"
          type="submit"
          disabled={isLoading}
          aria-label="Send message"
        >
          Send
        </button>
      </div>
      {validationError && (
        <p id="prompt-error" className="prompt-validation-error" role="alert">
          {validationError}
        </p>
      )}
    </form>
  );
}
